export const hideProview = () => {
  const element = document?.getElementById("proview_root");
  if (element) {
    element.style.backgroundColor = "#fff";
    element.style.display = "none";
  }
};
